import React, { Component } from 'react';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import {StandardPage} from "../../Common/pages/StandardPage";
import HorseRacingMostFollowed from "./HorseRacingMostFollowed";
import {RightColumn} from "../../Common/pages/RightColumn";
import HorseRacingAbcGuide from "./HorseRacingAbcGuide";

@catchLifeCycleErrors
export default class HorseRacingAbcGuidePage extends Component {
  render() {
    const { location, params } = this.props;

    return (
      <StandardPage sport="racing" title="Naps Table & Tips" >
        <div className="main-layout-left-column">
          <div className="main-layout-block last-desktop">
            <HorseRacingAbcGuide location={location} params={params} />
          </div>
          <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
            <HorseRacingMostFollowed location={location} plainTitle />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingAbcGuidePage.js